// Faste strukturelle data for Henneberg Byggeri ApS

export const companyInfo = {
  name: "Henneberg Byggeri ApS",
  cvr: "43497944",
  phone: "31444011",
  email: "mail@hennebergbyggeri.dk",
  address: "Vr Janderupvej 11, 6851 Janderup Vestj",
  openingHours: [
    { days: "Mandag - Torsdag", hours: "07:00 - 16:00" },
    { days: "Fredag", hours: "07:00 - 14:00" },
    { days: "Lørdag - Søndag", hours: "Lukket" }
  ],
  socials: {
    facebook: "https://facebook.com",
    instagram: "https://instagram.com"
  }
};

export const services = [
  {
    id: "bygningsrenovering",
    title: "Bygningsrenovering",
    icon: "Wrench",
    image: "https://assets.auxodev.dk/assets/531e2906-0b4f-4a2d-bfb4-6b0bf7bd2bc6/image00029.jpeg",
    shortDescription: "Professionel renovering og modernisering af ældre ejendomme med respekt for den oprindelige stil.",
    longDescription: "Vi har stor erfaring med renovering af både private boliger og erhvervsejendomme. Uanset om det drejer sig om en nænsom facaderenovering, modernisering af stueetagen eller en totalrenovering af en ældre murmestervilla, sikrer vi et resultat af højeste kvalitet. Vi rådgiver dig hele vejen igennem materialevalg og løsninger, så husets sjæl bevares, samtidig med at komforten og energivenligheden bringes op til moderne standarder.",
    benefits: [
      "Bevaring af bygningens oprindelige sjæl og arkitektur",
      "Forbedret indeklima og markant lavere varmeregning",
      "Værdiforøgelse af din bolig eller erhvervsejendom",
      "Professionel rådgivning om materialer og energiløsninger"
    ],
    process: [
      { title: "Besigtigelse & Rådgivning", desc: "Vi gennemgår ejendommen sammen og drøfter dine ønsker og behov." },
      { title: "Uforpligtende Tilbud", desc: "Du modtager et detaljeret tilbud med en klar tidsplan og faste priser." },
      { title: "Udførelse af Håndværk", desc: "Vores erfarne tømrere udfører arbejdet med fokus på præcision og kvalitet." },
      { title: "Aflevering & Gennemgang", desc: "Vi gennemgår det færdige resultat sammen for at sikre, at alt er perfekt." }
    ],
    seo: {
      title: "Bygningsrenovering - Henneberg Byggeri ApS",
      description: "Få udført professionel bygningsrenovering og modernisering af din bolig i Janderup og omegn. Vi sikrer høj kvalitet og respekt for husets oprindelige stil."
    }
  },
  {
    id: "nybyggeri",
    title: "Nybyggeri",
    icon: "Home",
    image: "https://assets.auxodev.dk/assets/531e2906-0b4f-4a2d-bfb4-6b0bf7bd2bc6/image00005.jpeg",
    shortDescription: "Opførelse af moderne, arkitekttegnede lavenergi-huse og tilbygninger i totalentreprise.",
    longDescription: "Drømmer du om et helt nyt hus, eller har du brug for en funktionel tilbygning? Vi opfører moderne parcelhuse, funkisvillaer og tilbygninger i tæt samarbejde med dig. Som din totalentreprenør styrer vi hele processen fra de første skitser til nøglerne overdrages. Vi lægger stor vægt på gennemsigtighed, punktlig levering og kompromisløst håndværk, så du trygt kan læne dig tilbage, mens dit drømmehus skyder op.",
    benefits: [
      "Skræddersyede løsninger tilpasset din families behov",
      "Fokus på moderne lavenergiløsninger og bæredygtighed",
      "Totalentreprise – én fast kontaktperson gennem hele forløbet",
      "Fast pris og aflevering til aftalt tid uden ubehagelige overraskelser"
    ],
    process: [
      { title: "Idémøde & Skitsering", desc: "Vi afstemmer forventninger, tegner de første streger og drøfter budgettet." },
      { title: "Projektering & Myndighedsgodkendelse", desc: "Vi udarbejder de endelige tegninger og søger om byggetilladelse." },
      { title: "Byggefase", desc: "Selve opførelsen af huset påbegyndes under tæt opsyn og koordinering." },
      { title: "Nøgleoverdragelse", desc: "Vi afleverer dit nøglefærdige drømmehus efter en grundig fælles gennemgang." }
    ],
    seo: {
      title: "Nybyggeri - Henneberg Byggeri ApS",
      description: "Går du i byggetanker? Henneberg Byggeri ApS opfører moderne, arkitekttegnede lavenergi-huse og funktionelle tilbygninger i totalentreprise."
    }
  },
  {
    id: "tagarbejde",
    title: "Tagarbejde",
    icon: "Hammer",
    image: "https://assets.auxodev.dk/assets/531e2906-0b4f-4a2d-bfb4-6b0bf7bd2bc6/image00012.jpeg",
    shortDescription: "Nyt tag, efterisolering og tagrender. Vi sikrer et tæt og smukt tag, der holder i mange årtier.",
    longDescription: "Taget er husets vigtigste klimaskærm. Vi udfører alt inden for tagarbejde – lige fra lægning af nyt tegltag, eternittag eller paptag til reparationer, efterisolering og montering af tagrender. Vi sørger for, at din tagkonstruktion er sund, tæt og optimalt isoleret, hvilket ikke alene beskytter dit hus mod vind og vejr, men også forbedrer din boligs energimærke og reducerer dit varmeforbrug markant.",
    benefits: [
      "Langtidsholdbare tagløsninger i højeste materialekvalitet",
      "Efterisolering der reducerer varmeregningen og forbedrer indeklimaet",
      "Professionel montering af zink- eller plasttagrender",
      "Etablering af smukke kviste og ovenlysvinduer for mere dagslys"
    ],
    process: [
      { title: "Tagtjek & Rådgivning", desc: "Vi vurderer dit nuværende tags stand og rådgiver om den bedste løsning." },
      { title: "Valg af Tagtype", desc: "Vi hjælper dig med at vælge de rette tagsten, farver og isoleringstykkelser." },
      { title: "Effektiv Udførelse", desc: "Vi lægger det nye tag hurtigt og professionelt for at minimere gener." },
      { title: "Kvalitetskontrol", desc: "Vi sikrer, at alle samlinger, inddækninger og tagrender er 100% tætte." }
    ],
    seo: {
      title: "Tagarbejde - Henneberg Byggeri ApS",
      description: "Trænger huset til nyt tag? Vi udfører professionelt tagarbejde, efterisolering og montering af tagrender i Janderup, Varde og Esbjerg."
    }
  },
  {
    id: "traekonstruktioner",
    title: "Trækonstruktioner",
    icon: "Trees",
    image: "https://assets.auxodev.dk/assets/531e2906-0b4f-4a2d-bfb4-6b0bf7bd2bc6/image00035.jpeg",
    shortDescription: "Specialbyggede træterrasser, carporte, pergolaer og skure tilpasset dit uderum.",
    longDescription: "Træ er et fantastisk, levende materiale, der skaber varme og atmosfære. Vi har specialiseret os i skræddersyede trækonstruktioner til uderummet. Vi designer og bygger eksklusive træterrasser i hårdttræ eller lærketræ, funktionelle carporte med integrerede redskabsrum, elegante pergolaer og robuste skure. Alt sammen opført med fokus på holdbarhed, præcision og smukke detaljer, der komplementerer din bolig.",
    benefits: [
      "Skræddersyet design der passer perfekt til din have og bolig",
      "Anvendelse af vejrbestandige og slidstærke træsorter",
      "Solidt tømrerarbejde der modstår det omskiftelige danske vejr",
      "Flot finish med skjulte skruer og gennemtænkte detaljer"
    ],
    process: [
      { title: "Uderums-snak", desc: "Vi mødes i din have for at se på mulighederne og opmåle arealet." },
      { title: "Design & Materialevalg", desc: "Vi præsenterer forslag til layout og rådgiver om de forskellige træsorter." },
      { title: "Opbygning af Konstruktion", desc: "Vi etablerer et solidt fundament og opbygger trækonstruktionen." },
      { title: "Færdiggørelse", desc: "Vi sliber kanter, monterer de sidste detaljer og rydder pænt op." }
    ],
    seo: {
      title: "Trækonstruktioner - Henneberg Byggeri ApS",
      description: "Få bygget en eksklusiv træterrasse, carport eller pergola af højeste kvalitet. Vi skræddersyr trækonstruktioner til dit uderum i Vestjylland."
    }
  },
  {
    id: "doere-og-vinduer",
    title: "Døre og Vinduer",
    icon: "DoorOpen",
    image: "https://assets.auxodev.dk/assets/531e2906-0b4f-4a2d-bfb4-6b0bf7bd2bc6/image00022.jpeg",
    shortDescription: "Udskiftning og montering af døre og vinduer i høj kvalitet for bedre isolering og sikkerhed.",
    longDescription: "Nye døre og vinduer kan fuldstændig forandre dit hus' udseende, samtidig med at det forbedrer isoleringsevnen og indbrudssikkerheden markant. Vi tilbyder professionel opmåling, rådgivning og montering af alle typer døre og vinduer – herunder klassiske dannebrogsvinduer, moderne træ-alu partier, store skydedøre og sikre yderdøre. Vi samarbejder med førende danske producenter for at sikre dig den bedste kvalitet og garanti.",
    benefits: [
      "Markant forbedring af boligens isoleringsevne og energimærke",
      "Øget sikkerhed mod indbrud med moderne låsesystemer",
      "Minimal vedligeholdelse med moderne træ-alu elementer",
      "Større lysindfald og forbedret indeklima i hverdagen"
    ],
    process: [
      { title: "Opmåling & Rådgivning", desc: "Vi foretager præcis opmåling og rådgiver om stilarter og funktionalitet." },
      { title: "Bestilling", desc: "Vi bestiller elementerne direkte hos anerkendte danske producenter." },
      { title: "Montering", desc: "Vi afmonterer de gamle elementer og monterer de nye hurtigt og præcist." },
      { title: "Fugearbejde & Finish", desc: "Vi afslutter med professionel fugning og indvendige lister for et perfekt resultat." }
    ],
    seo: {
      title: "Døre og Vinduer - Henneberg Byggeri ApS",
      description: "Udskiftning af døre og vinduer i Janderup og omegn. Få monteret energirigtige og sikre døre og vinduer af professionelle tømrere."
    }
  }
];

export const whyChooseUs = [
  {
    title: "Kvalitetsmaterialer",
    description: "Vi går aldrig på kompromis med materialerne. Vi samarbejder udelukkende med anerkendte danske leverandører for at sikre, at dit byggeri holder i generationer."
  },
  {
    title: "Høj faglighed",
    description: "Vores tømrere er veluddannede, passionerede og stolte af deres håndværk. Vi holder os opdateret med de nyeste byggeteknikker og gældende krav."
  },
  {
    title: "Personlig rådgivning",
    description: "Et godt byggeri starter med god dialog. Vi lytter til dine drømme og rådgiver dig ærligt om de bedste løsninger, materialer og økonomi."
  },
  {
    title: "Lokalt engagement",
    description: "Som lokal tømrervirksomhed i Janderup værner vi om vores gode ry. Vi støtter lokalsamfundet og er altid lige i nærheden, når du har brug for os."
  },
  {
    title: "Punktlig levering",
    description: "En aftale er en aftale. Vi lægger en realistisk tidsplan og overholder den, så du kan planlægge din hverdag uden uforudsete forsinkelser."
  }
];
